<mat-tab-group (selectedTabChange)="tabChange($event)">
  <mat-tab *ngFor="let item of filters" [label]="item.value | translatePropertyType">
    <ng-template mat-tab-label *ngIf="item.requiredTooltip">
      {{ item.value }} <span class="single-filter-bar-required-icon" [matTooltip]="item.requiredTooltip">*</span>
    </ng-template>
  </mat-tab>
</mat-tab-group>
